import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import ValidationFormGroup from "./ValidationFormGroup/ValidationFormGroup";
export default class ValidationFieldset extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        if (props.requirements.length === 0) {
            return null;
        }
        return (<fieldset className="fieldset">
				{props.showLegend && (<legend>
						<div>
							<div className="vr vr_x3"/>
							<div className="vr vr_x3">
								<span className="hdg hdg_1">
									<FormattedMessage id="forms.accountValidation.validation.label" defaultMessage="Please validate to continue"/>
								</span>
							</div>
						</div>
					</legend>)}

				{props.requirements.map(requirement => (<ValidationFormGroup key={requirement.id} requirement={requirement} value={props.value[requirement.id] || ""} error={props.errors[requirement.id]} onChange={this._handleChange} locale={props.locale}/>))}
			</fieldset>);
    }
    _handleChange(id, value) {
        this.props.onChange({
            ...this.props.value,
            [id]: value
        });
    }
}
ValidationFieldset.defaultProps = {
    showLegend: true
};



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/ValidtationFieldset/ValidationFieldset.tsx